export default "__VITE_ASSET__7345d212__"